
//生成mkey所需要的后缀
export const SUFFIX = 'F6B5EF0CA4639B0D8ED172F749B15D69';


// 版本号
export const VERSION = '3.5.01';

const web_url = (window.location.href).split("/")[2];
let _BASE_URL = "", _LOGIN_URL = "", _manageConfig = {};

// 文件上传的路径
let _resourceUrl = 'https://file.woxshare.com';
switch (web_url) {
    // 本地调试
    case "localhost:3000":
        // _BASE_URL = 'https://saas-test.woxshare.com';
        // _LOGIN_URL = 'http://i-test.woxshare.com';
        _BASE_URL = 'https://wox2019.woxshare.com';
        _LOGIN_URL = 'https://i.woxshare.com';
        _manageConfig = {
            groupName: '沃享',
            mainLogo: `${_resourceUrl}/utility/operationLogo/wox_data_platform.png`,
        };
        break;

    // 预备线环境 UAT
    case "i-work.woxshare.com":
        _BASE_URL = 'https://work-test.woxshare.com';
        _LOGIN_URL = 'https://i-work.woxshare.com';
        _manageConfig = {
            groupName: '沃享',
            mainLogo: `${_resourceUrl}/utility/operationLogo/wox_data_platform.png`,
        };
        break;
    // 沃享测试线
    case "i-test.woxshare.com":
        _BASE_URL = 'https://saas-test.woxshare.com';
        _LOGIN_URL = 'http://i-test.woxshare.com';
        _manageConfig = {
            groupName: '沃享',
            mainLogo: `${_resourceUrl}/utility/operationLogo/wox_data_platform.png`,
        };
        break;
    // 沃享预备线
    case "saas-beta-i.woxshare.com":
        _resourceUrl = 'https://file.woxshare.com'
        _BASE_URL = 'https://saas-beta.woxshare.com';
        _LOGIN_URL = 'https://saas-beta-i.woxshare.com';
        _manageConfig = {
            groupName: '沃享',
            mainLogo: `${_resourceUrl}/utility/operationLogo/wox_data_platform.png`,
        };
        break;
    // 沃享正式线
    case "i.woxshare.com":
        _BASE_URL = 'https://wox2019.woxshare.com';
        _LOGIN_URL = 'https://i.woxshare.com';
        _manageConfig = {
            groupName: '沃享',
            mainLogo: `${_resourceUrl}/utility/operationLogo/wox_system_operation.png`,
        };
        break;
    // 纽宾凯测试线
    case "i-test.xckjwh.com":
        _BASE_URL = 'http://i-test.xckjwh.com';
        _LOGIN_URL = 'http://i-test.xckjwh.com';
        _manageConfig = {
            groupName: '纽宾凯',
            mainLogo: `${_resourceUrl}/utility/operationLogo/nbk_small.png`,
        };
        break;
    // 纽宾凯正试线
    case "i.xckjwh.com":
        _BASE_URL = 'http://i.xckjwh.com';
        _LOGIN_URL = 'http://i.xckjwh.com';
        _manageConfig = {
            groupName: '纽宾凯',
            mainLogo: `${_resourceUrl}/utility/operationLogo/nbk_small.png`,
        };
        break;
    // 佳兆业正式线
    case "i.debc.cn":
        _BASE_URL = 'https://api.debc.cn';
        _LOGIN_URL = 'https://i.debc.cn';
        _manageConfig = {
            groupName: '佳兆业',
            mainLogo: `${_resourceUrl}/utility/operationLogo/wox_system_operation.png`,
        };
        break;
    // 佳兆业测式线（服务器暂不可用）
    case "syitest.kaisasso.com":
        _BASE_URL = 'https://syitest.kaisasso.com';
        _LOGIN_URL = 'https://syitest.kaisasso.com';
        _manageConfig = {
            groupName: '佳兆业',
            mainLogo: `${_resourceUrl}/utility/operationLogo/wox_system_operation.png`,
        };
        break;
    // 华为云部署
    case "hwy-saas-i.woxshare.com":
        _resourceUrl = 'https://hwy-saas-file.woxshare.com'
        _BASE_URL = 'https://hwy-saas.woxshare.com';
        _LOGIN_URL = 'https://hwy-saas-i.woxshare.com';
        _manageConfig = {
            groupName: '沃享',
            mainLogo: `${_resourceUrl}/utility/operationLogo/wox_system_operation.png`,
        };
        break;
    // 华侨城云部署
    case "member.octharbour.com":
        _resourceUrl = 'https://crm.octharbour.com'
        _BASE_URL = 'https://vip.octharbour.com';
        _LOGIN_URL = 'https://member.octharbour.com';
        _manageConfig = {
            groupName: '沃享',
            mainLogo: `${_resourceUrl}/utility/operationLogo/wox_system_operation.png`,
        };
        break;
    default:
        // _BASE_URL = 'https://saas-test.woxshare.com';
        // _LOGIN_URL = 'http://i-test.woxshare.com';
        _BASE_URL = 'https://wox2019.woxshare.com';
        _LOGIN_URL = 'https://i.woxshare.com';
        _manageConfig = {
            groupName: '沃享',
            mainLogo: `${_resourceUrl}/utility/operationLogo/wox_system_operation.png`,
        };
        break;
}

export const BASE_URL = _BASE_URL;
export const LOGIN_URL = _LOGIN_URL; 
export const manageConfig = _manageConfig;
export const resourceUrl = _resourceUrl


// WEBPACK FOOTER //
// ./src/common/url.js